import { createHandlerChainRunner, Handler, HasOnSuccess, } from "@insite/client-framework/HandlerCreator";
import {
    getCustomerPartNumbers,
    GetCustomerPartNumbersApiParameter,
} from "@thos/Services/CustomerPartNumberService";
import { CustomerPartNumberCollectionModel } from "@thos/Services/ThosApiModels";

type Parameter = GetCustomerPartNumbersApiParameter &
    HasOnSuccess<CustomerPartNumberCollectionModel>;


type Props = {
    apiResult: CustomerPartNumberCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getCustomerPartNumbers({
        partNumber: props.parameter.partNumber,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
    // return props.apiResult;
};

export const chain = [SendDataToApi, ExecuteOnSuccessCallback];

const getCustomerPartNumberId = createHandlerChainRunner(chain, "getCustomerPartNumberId");
export default getCustomerPartNumberId;
